import { boolean, object, optional } from 'superstruct';

/**
 * For each section, when true, reset that section of all users with the role to
 * the union of their roles.
 */
export const ApplyEditsToUsersOptionsDto = object({
  superuser: optional(boolean()),
  permissions: optional(boolean())
});